import { render, staticRenderFns } from "./monaco.vue?vue&type=template&id=6a362ebb&"
import script from "./monaco.vue?vue&type=script&lang=js&"
export * from "./monaco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports